import React, { useEffect } from 'react';

function CategoryPage({ title, image, description, details }) {
    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove('preload');
    }, []);

    return (
        <div className="category-page">
            <header className="category-header fade-in" style={{ backgroundImage: `url(${image})` }}>
                <div className="overlay"></div>
                <h1>{title}</h1>
            </header>
            <main className="category-content">
                <section className="category-description fade-in">
                    <p>{description}</p>
                </section>
                <section className="category-details">
                    <h2 className="fade-in">Détails</h2>
                    <ul>
                        {details.map((detail, index) => (
                            <li key={index} className="fade-in">{detail}</li>
                        ))}
                    </ul>
                </section>
            </main>
            <footer className="category-footer fade-in">
                <a href="/contact" className="cta-button">Contactez-nous</a>
            </footer>

            <style jsx>{`
                .category-page {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 100%;
                }

                .category-header {
                    width: 100%;
                    height: 500px;
                    background-size: cover;
                    background-position: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    color: #fff;
                    text-shadow: 0 2px 5px rgba(0, 0, 0, 0.7);
                }

                .category-header .overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 1;
                }

                .category-header h1 {
                    position: relative;
                    z-index: 2;
                    font-size: 3rem;
                    text-align: center;
                }

                .category-content {
                    max-width: 800px;
                    padding: 40px 20px;
                    text-align: center;
                }

                .category-description p {
                    font-size: 1.2rem;
                    margin-bottom: 30px;
                    line-height: 1.6;
                    color: #333;
                }

                .category-details {
                    margin-top: 20px;
                }

                .category-details h2 {
                    font-size: 2rem;
                    margin-bottom: 15px;
                    color: #20453d;
                }

                .category-details ul {
                    list-style-type: disc;
                    padding-left: 20px;
                    text-align: left;
                }

                .category-details ul li {
                    font-size: 1rem;
                    line-height: 1.8;
                    color: #555;
                }

                .category-footer {
                    margin-top: 30px;
                    margin-bottom: 20px;
                }

                .cta-button {
                    padding: 12px 24px;
                    background-color: #C0A26B; /* Gold */
                    color: #20453d; /* Dark green */
                    text-decoration: none;
                    border-radius: 25px;
                    transition: background-color 0.3s ease, transform 0.3s ease;
                }

                .cta-button:hover {
                    background-color: #a67c52;
                    transform: scale(1.1);
                }

                .fade-in {
                    opacity: 0;
                    transform: translateY(20px);
                    animation: fadeIn 1s ease-out forwards;
                }

                .preload .fade-in {
                    opacity: 0;
                    transform: translateY(20px);
                    animation: none;
                }

                @keyframes fadeIn {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 768px) {
                    .category-header {
                        height: 400px;
                    }

                    .category-header h1 {
                        font-size: 2.5rem;
                    }

                    .category-content {
                        padding: 20px;
                    }
                }
            `}</style>
        </div>
    );
}

export default CategoryPage;
